module.exports = __webpack_public_path__ + "img/uploadline.f401a273.svg";